import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'truncate',
    standalone: false
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, limit = 4, completeWords = false, ellipsis = '..') {
    if (completeWords) {
      limit = value.substring(0, limit).lastIndexOf(' ') > 0 ? value.substring(0, limit).lastIndexOf(' ') : limit;
    }
    return value.length > limit ? value.substring(0, limit) + ellipsis : value;
  }
}
